import React from 'react';
import { Card } from './ui/Card';
import { Sparkles, Scissors, Zap, Eye, HandMetal } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-16 md:py-20 bg-gradient-to-b from-[#FDF4FF] to-[#FDF2F8]" data-id="element-239">
      <div className="max-w-6xl mx-auto px-4" data-id="element-240">
        <div className="text-center mb-12 md:mb-16" data-id="element-241">
          <span className="text-[#9333EA] font-bold tracking-wider uppercase mb-2 block text-sm" data-id="element-242">
            ✅ LA SOLUCIÓN
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4 md:mb-6" data-id="element-243">
            💎 <span className="gold-title" data-id="element-244">MegaPack Estética Integral</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-245">
            No es un curso aislado. Es una formación completa, diseñada para que
            cualquier persona pueda aprender servicios reales del mercado
            estético, paso a paso y con criterio profesional.
          </p>
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mt-6 md:mt-8 text-sm md:text-lg font-bold text-gray-800" data-id="element-246">
            <span className="flex items-center" data-id="element-247">📖 Abrís el material</span>
            <span className="flex items-center" data-id="element-248">🧠 Entendés qué hacer</span>
            <span className="flex items-center" data-id="element-249">✍️ Aplicás con seguridad</span>
          </div>
        </div>

        <h3 className="text-2xl md:text-3xl font-bold text-center mb-6 md:mb-10" data-id="element-250">
          📚 ¿Qué incluye exactamente el MegaPack?
        </h3>
        <p className="text-center text-gray-500 mb-8 md:mb-12 uppercase tracking-widest font-semibold text-xs md:text-sm" data-id="element-251">
          Recibís 6 TOMOS PROFESIONALES (60 páginas cada uno)
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-252">
          <Card className="p-6 border-t-4 border-purple-500 hover:shadow-2xl transition-shadow duration-300" data-id="element-253">
            <div className="mb-4 bg-purple-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto" data-id="element-254">
              <Sparkles className="w-8 h-8 text-purple-500" data-id="element-255" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3 text-center" data-id="element-256">
              1️⃣ Microneedling Profesional
            </h4>
            <p className="text-gray-600 text-center text-sm leading-relaxed" data-id="element-257">
              Aprendé uno de los tratamientos más solicitados para: Manchas,
              Cicatrices de acné, Antiage, Estrías. Servicio de ticket alto y
              alta demanda.
            </p>
          </Card>

          <Card className="p-6 border-t-4 border-pink-400 hover:shadow-2xl transition-shadow duration-300" data-id="element-258">
            <div className="mb-4 bg-pink-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto" data-id="element-259">
              <Eye className="w-8 h-8 text-pink-400" data-id="element-260" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3 text-center" data-id="element-261">
              2️⃣ Micropigmentación Profesional
            </h4>
            <p className="text-gray-600 text-center text-sm leading-relaxed" data-id="element-262">
              Dominá: Diseño de cejas, Teoría del color, Técnica pelo a pelo,
              Shading, Labios. Uno de los servicios más rentables del sector.
            </p>
          </Card>

          <Card className="p-6 border-t-4 border-yellow-400 hover:shadow-2xl transition-shadow duration-300" data-id="element-263">
            <div className="mb-4 bg-yellow-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto" data-id="element-264">
              <Scissors className="w-8 h-8 text-yellow-500" data-id="element-265" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3 text-center" data-id="element-266">
              3️⃣ Depilación con Cera Profesional
            </h4>
            <p className="text-gray-600 text-center text-sm leading-relaxed" data-id="element-267">
              Servicio base, constante y de bajo costo. Ideal para comenzar a
              generar ingresos rápidos.
            </p>
          </Card>

          <Card className="p-6 border-t-4 border-blue-400 hover:shadow-2xl transition-shadow duration-300" data-id="element-268">
            <div className="mb-4 bg-blue-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto" data-id="element-269">
              <Zap className="w-8 h-8 text-blue-500" data-id="element-270" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3 text-center" data-id="element-271">
              4️⃣ Aparatología + Depilación Láser
            </h4>
            <p className="text-gray-600 text-center text-sm leading-relaxed" data-id="element-272">
              Fundamentos técnicos + estructura de servicio rentable.
              Posicionamiento profesional inmediato.
            </p>
          </Card>

          <Card className="p-6 border-t-4 border-indigo-400 hover:shadow-2xl transition-shadow duration-300" data-id="element-273">
            <div className="mb-4 bg-indigo-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto" data-id="element-274">
              <Eye className="w-8 h-8 text-indigo-500" data-id="element-275" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3 text-center" data-id="element-276">
              5️⃣ Lashista Profesional
            </h4>
            <p className="text-gray-600 text-center text-sm leading-relaxed" data-id="element-277">
              Extensiones de pestañas paso a paso. Servicio recurrente, Clientes
              frecuentes, Ingresos constantes.
            </p>
          </Card>

          <Card className="p-6 border-t-4 border-rose-400 hover:shadow-2xl transition-shadow duration-300" data-id="element-278">
            <div className="mb-4 bg-rose-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto" data-id="element-279">
              <HandMetal className="w-8 h-8 text-rose-500" data-id="element-280" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3 text-center" data-id="element-281">
              6️⃣ Manicuría Profesional
            </h4>
            <p className="text-gray-600 text-center text-sm leading-relaxed" data-id="element-282">
              Uno de los servicios más solicitados. Alta rotación, Demanda
              constante, Ingreso estable.
            </p>
          </Card>
        </div>
      </div>
    </section>;
}